import { getD3AConfig } from 'src/api/config';
import d3aservice, {
  GetDataAgreementInput,
  GetDataAgreementOutput,
  GetReportInput,
  GetReportOutput,
  ListDataAgreementsInput,
  ListDataAgreementsOutput,
  ListReportsInput,
  ListReportsOutput,
  StartReportGenerationInput,
  StartReportGenerationOutput,
  ValidateContextForDataAgreementInput,
  ValidateContextForDataAgreementOutput,
} from 'aws-sdk/clients/d3aservice';
import basicCallWrapper from 'src/api/client_call';

const config = getD3AConfig();

let d3aClient = new d3aservice();

export async function initD3AServiceClient(credentials) {
  const d3aServiceClientConfig = {
    region: config.region,
    endpoint: config.endpoint,
    credentials: credentials,
  };

  d3aClient = new d3aservice(d3aServiceClientConfig);
}

export const getReport = (input: GetReportInput) => {
  return basicCallWrapper<GetReportInput, GetReportOutput>(d3aClient, d3aClient.getReport)(input);
};

export const listReports = (input: ListReportsInput) => {
  return basicCallWrapper<ListReportsInput, ListReportsOutput>(d3aClient, d3aClient.listReports)(input);
};

export const startReportGeneration = (input: StartReportGenerationInput) => {
  return basicCallWrapper<StartReportGenerationInput, StartReportGenerationOutput>(
    d3aClient,
    d3aClient.startReportGeneration,
  )(input);
};

export const listDataAgreements = (input: ListDataAgreementsInput) => {
  return basicCallWrapper<ListDataAgreementsInput, ListDataAgreementsOutput>(
    d3aClient,
    d3aClient.listDataAgreements,
  )(input);
};
export const getDataAgreement = (input: GetDataAgreementInput) => {
  return basicCallWrapper<GetDataAgreementInput, GetDataAgreementOutput>(d3aClient, d3aClient.getDataAgreement)(input);
};
export const validateContextForDataAgreement = (input: ValidateContextForDataAgreementInput) => {
  return basicCallWrapper<ValidateContextForDataAgreementInput, ValidateContextForDataAgreementOutput>(
    d3aClient,
    d3aClient.validateContextForDataAgreement,
  )(input);
};
